export default "__VITE_ASSET__pmio5Ywr__"